<template>
  <div class="container">
    <div class="box-p">
      <div class="title">欢迎注册万顺代驾司机</div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="phone"
          type="tel"
          maxlength="11"
          name="手机号"
          placeholder="请输入手机号"
          center
          clearable
        />
        <div style="margin: 50px 16px 0 16px">
          <van-button block type="info" native-type="submit" color="#010212" size="large"
                      :disabled="phone&&phone.length==11?false:true">下一步
          </van-button>
        </div>
      </van-form>
    </div>
    <van-dialog
      v-model="regShow"
      show-cancel-button
      title="温馨提示"
      message=""
      confirm-button-text="我已同意"
      confirm-button-color="#1989fa"
      cancel-button-text="我不同意"
      cancel-button-color="#666"
      @confirm="clickConfirm"
      @cancel="clickCancel">
      <div class="reg-box">
        <p>在您注册和登录产品账号的过程中，您需要完成流程并确认同意<span class="org" @click="goPage('服务协议')">《服务协议》</span>和<span
          class="org" @click="goPage('隐私政策')">《隐私政策》</span>（以下简称“法律文件”）。</p>
        <p>
          请您在确认同意之前务必仔细阅读、充分理解法律文件中的条款内容，尤其是法律文件中粗体标识的部分。如果您不同意上述法律文件或其中的任何条款，请您停止注册或登录。如果您同意上述法律文件，请您阅读和确认同意法律文件并按照正常登录注册流程完成</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
  import mobileType from '../../utils/mobileType';
  import util from '../../utils/util';
  import {
    getSmsCodeSJ,
  } from '@/apis/common';

  export default {
    data() {
      return {
        params: {
          channel: '1020000000',
          deviceId: util.getUUID(),
          platform: 4,
          softVersion: '4.7.8',
          sysVersion: 'TNY-AL00,10',
          token: '',
          areaCode: '',
        },
        phone: '',
        password: '',
        smsType: 0,//业务类型 0 注册 1 修改密码 2 绑卡 3 修改手机号 4 司机注销
        regShow: false,//协议
      };
    },
    created() {
    },
    mounted() {
    },
    methods: {
      goPage(val) {
        if (val == '服务协议') {
          this.$router.push('/home/serviceAgreement');
        } else if (val == '隐私政策') {
          this.$router.push('/home/privacyPolicy');
        } else {
        }
      },
      clickConfirm() {
        this.$router.push('/home/reg');
      },
      clickCancel() {
        // this.$router.go(-1);//返回上一层
      },
      onSubmit(values) {
        const reg = /^1[3456789]\d{9}$/;
        if (this.phone) {
          if (!reg.test(this.phone)) {
            return this.$toast('请输入正确手机号');
          }
        } else {
          return this.$toast('请输入手机号');
        }
        this.sendLogin();
      },
      async sendLogin() {
        let params = {
          channel: this.params.channel,
          deviceId: this.params.deviceId,
          platform: this.params.platform,
          softVersion: this.params.softVersion,
          sysVersion: this.params.sysVersion,
          token: null,
          data: {
            phone: this.phone,
            smsType: this.smsType,//业务类型 0 注册 1 修改密码 2 绑卡 3 修改手机号 4 司机注销
          },
        };
        params.data = JSON.stringify(params.data);
        try {
          const data = await getSmsCodeSJ(params);
          if (data.code == 1) {
            this.regShow=true;
          } else {
            this.$toast(data.msg);
          }
        } catch (error) {
        }
      },
    },
  };
</script>
<style scoped lang="less">
  .box-p {
    padding: 0 20px;

    .van-cell::after {
      border-bottom: 1px solid #EBEBEB;
    }

    .title {
      font-size: 28px;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
      text-align: center;
      margin: 30px 0 100px 0;
    }
  }

  .reg-box {
    padding: 20px;

    p {
      line-height: 22px;
      font-size: 14px;
    }
  }

</style>

